import { createFileRoute } from '@tanstack/react-router';
import { Alert, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { PlatformRole, hasRole, useSession } from '../auth/session';
import { ResellersScreen } from '../features/resellers/ResellersScreen';

/**
 * Partner administration. Platform-level: a partner belongs to no tenant, it is what a set of
 * tenants belongs to.
 *
 * Staff only, including the read. Margins are commercially sensitive between partners, so this is
 * deliberately not a screen a partner's own administrators can reach — the API enforces the same
 * bar, and this only decides what to render.
 */
export const Route = createFileRoute('/resellers')({
  component: ResellersPage,
});

function ResellersPage() {
  const { t } = useTranslation('partners');
  const { data: session } = useSession();

  if (!hasRole(session, PlatformRole.MspAdmin)) {
    return (
      <Stack gap="md" maw={560}>
        <Alert color="red" title={t('noAccessTitle')}>
          {t('noAccessBody')}
        </Alert>
      </Stack>
    );
  }

  return <ResellersScreen />;
}
